import { Paper, PaperProps, SxProps, Theme, useTheme } from '@mui/material';

import { panelSx } from './Panel.styles';

interface PanelProps extends Omit<PaperProps, 'elevation'> {
  ignited?: boolean;
  danger?: boolean;
}

export const Panel: React.FC<PanelProps> = ({
  ignited = false,
  danger = false,
  ...props
}) => {
  const theme = useTheme();

  return (
    <Paper
      {...props}
      sx={{ ...panelSx(theme), ...props.sx } as SxProps<Theme>}
      elevation={0}
      className={`${props.className || ''} ${ignited ? 'ignited' : ''} ${danger ? 'danger' : ''} CTPanel-root`}
    />
  );
};
